(function (window) {
    'use strict';

    // Dependencies
    var controller = window.controller;
    var configureglobals = window.configureglobals;
    var common = window.common;
    var TBGBOTip = window.TBGBOTip;
    var TBGBOLargeFormatTip = window.TBGBOLargeFormatTip;
    var tags = window.tags;
    var forms = window.forms;
    var confUtil = window.confUtil;

    // Constants
    var QUANTITYEF = 'QUANTITYEF';
    var QUANTITY_PER_VERSION_EF = 'QUANTITY_PER_VERSION_EF';
    var VERSION_COUNT_EF = 'VERSION_COUNT_EF';

    // Local Service Private Vars
    var onFocusVersionCount,
        onFocusQuantity,
        onFocusQuantityPerVersion;

    // Public Service Definition
    window.quantityConfigureController = {
        generateQuantity: generateQuantity,
        addVersions: addVersions,
        removeVersions: removeVersions,
        onVersionCountFocus: onVersionCountFocus,
        onVersionCountBlur: onVersionCountBlur,
        onQuantityPerVersionFocus: onQuantityPerVersionFocus,
        onQuantityPerVersionBlur: onQuantityPerVersionBlur,
        onQuantityFocus: onQuantityFocus,
        onQuantityBlur: onQuantityBlur
    };

    return;

    function generateQuantity () {
        var qtyContent = '';
        var verContent = '';
        var cquotedata = configureglobals.cquotedata;

        var quantityPerVerFieldError = common.validation.hasJobQuoteFieldMessagesFor(QUANTITY_PER_VERSION_EF);
        var quantityFieldError = common.validation.hasJobQuoteFieldMessagesFor(QUANTITYEF);
        var versionCountFieldError = common.validation.hasJobQuoteFieldMessagesFor(VERSION_COUNT_EF);

        var jc = configureglobals.clpjc || configureglobals.cpjc;
        var tip = TBGBOTip || TBGBOLargeFormatTip;

        var help = '';

        var quantityPerVersion,
            versionCount,
            totalQuantity;

        if (jc.showQtyTip) {
            help = tags.a('', 'javascript:help.tip(configureglobals.' + (configureglobals.clpjc ? 'clpjc' : 'cpjc') + ',\'qtyTip\',\'' + tip.QUANTITY + '\')', {
                id: 'qtyTip',
                cssClass: 'quoteHelp',
                tabindex: '-1',
                title: 'More Information'
            });
        }

        if (jc.editQty || cquotedata.privilegedMode) {
            if (cquotedata.externallyGenerated || cquotedata.versions.length > 1) {
                quantityPerVersion = cquotedata.quantityPerVersion === null ? '' : cquotedata.quantityPerVersion;
                versionCount = cquotedata.versionCount === null ? '' : cquotedata.versionCount;
                totalQuantity = cquotedata.quantity;

                verContent += '<table class="version-quantity">';

                if (!cquotedata.externallyGenerated) {
                    verContent += '<tr class="quantity-per"><td>' + help + tags.label(cquotedata.versionQuantityLabel, {
                        cssClass: 'config'
                    }) + '</td><td>';

                    verContent += forms.ef(QUANTITY_PER_VERSION_EF, quantityPerVersion, {
                        size: 5,
                        cssClass: 'configField' + (quantityPerVerFieldError ? ' error' : ''),
                        onfocus: 'quantityConfigureController.onQuantityPerVersionFocus()',
                        onblur: 'quantityConfigureController.onQuantityPerVersionBlur()'
                    }) + '</td></tr>';

                    verContent += '<tr><td colspan="2"><span id="quantityPerVersionFocus" class="changeFocusButton"><!-- dynamic --></span></td></tr>';

                    if (quantityPerVerFieldError) {
                        verContent += '<tr><td colspan="2">' + common.validation.generateJobQuoteFieldMessagesFor(QUANTITY_PER_VERSION_EF) + '</td></tr>';
                    }

                    // TODO provide label from server.
                    verContent += '<tr class="quantity-per"><td>' + tags.label('Number of Versions', {
                        cssClass: 'config'
                    }) + '</td><td>';

                    verContent += forms.ef(VERSION_COUNT_EF, versionCount, {
                        size: 5,
                        id: VERSION_COUNT_EF,
                        cssClass: 'configField' + (versionCountFieldError ? ' error' : ''),
                        onfocus: 'quantityConfigureController.onVersionCountFocus()',
                        onblur: 'quantityConfigureController.onVersionCountBlur()'
                    }) + '</td></tr>';

                    verContent += '<tr><td colspan="2"><span id="versionsFocus" class="changeFocusButton"><!-- dynamic --></span></td></tr>';

                    if (versionCountFieldError) {
                        verContent += '<tr><td colspan="2">' + common.validation.generateJobQuoteFieldMessagesFor(VERSION_COUNT_EF) + '</td></tr>';
                    }
                } else {
                    verContent += '<tr class="quantity-per"><td>' + tags.label('Number of Versions', {
                        cssClass: 'config'
                    }) + '</td><td>';

                    verContent += forms.ef(VERSION_COUNT_EF, versionCount, {
                        cssClass: 'noEdit',
                        style: 'opacity : 1',
                        disabled: true
                    }) + '</td></tr>';
                }

                verContent += '<tr class="total-v-quantity"><td><span>' + cquotedata.quantityLabel + '</span></td><td>' + forms.ef(QUANTITYEF, totalQuantity, {
                    cssClass: 'noEdit version-total sum-quantity' + (quantityFieldError ? ' error' : ''),
                    style: 'opacity : 1',
                    disabled: true
                }) + '</td></tr>';

                if (quantityFieldError) {
                    verContent += '<tr><td colspan="2">' + common.validation.generateJobQuoteFieldMessagesFor(QUANTITYEF) + '</td></tr>';
                }

                verContent += '</table>';

                verContent += '<div class="versionButtons">';
                if (!cquotedata.externallyGenerated) {
                    verContent += '<a href="javascript:quantityConfigureController.removeVersions();" class="versionButton versionButton_remove">Remove Versions</a>';
                }
                verContent += '<a href="javascript:detailedVersionsController.open();" class="versionButton versionButton_details">Edit Versions</a>';
                verContent += '</div>';
            } else {
                qtyContent += help + tags.label(cquotedata.quantityLabel, {
                    cssClass: 'config'
                });

                qtyContent += forms.ef(QUANTITYEF, cquotedata.quantity ? cquotedata.quantity : '', {
                    size: 5,
                    cssClass: 'configField' + (quantityFieldError ? ' error' : ''),
                    onblur: 'quantityConfigureController.onQuantityBlur()',
                    onfocus: 'quantityConfigureController.onQuantityFocus()'

                    // onblur: 'common.efBlur(\'' + QUANTITYEF + '\',\'quantity\', \'quantityFocus\')'
                });

                qtyContent += '<span id="quantityFocus" class="changeFocusButton"><!-- dynamic --></span>';

                if (quantityFieldError) {
                    qtyContent += common.validation.generateJobQuoteFieldMessagesFor(QUANTITYEF);
                }
            }

            if (!cquotedata.externallyGenerated && cquotedata.versions.length === 1 && jc.maxVersions > 1) {
                qtyContent += tags.a('Add Versions', 'javascript:quantityConfigureController.addVersions()', {
                    cssClass: 'addVersion'
                });
            }
        } else {
            qtyContent += tags.label(cquotedata.quantityLabel, {
                cssClass: 'config'
            });

            qtyContent += tags.div(cquotedata.quantity, {
                cssClass: 'noEdit'
            });
        }

        common.setOptionDiv('quantity', qtyContent);
        common.setOptionDiv('versions', verContent);
    }

    function addVersions () {
        var cquotedata = configureglobals.cquotedata;

        var configChangeDetails = {
            context: 'addVersions',
            category: confUtil.OPTION_CHANGE,
            value: ''
        };

        cquotedata.addVersions();

        controller.updateQuote(configChangeDetails);
    }

    function removeVersions () {
        window.confirmPanel.confirm('Are you sure you want to remove all version?', function () {
            var configChangeDetails = {
                context: 'removeVersions',
                category: confUtil.OPTION_CHANGE
            };

            var cquotedata = configureglobals.cquotedata;
            cquotedata.removeVersions();

            controller.updateQuote(configChangeDetails);
        }, null, { confirmText: 'Remove' });
    }

    function onQuantityPerVersionFocus () {
        onFocusQuantityPerVersion = getFormItemValue(QUANTITY_PER_VERSION_EF, document);
        common.efFocus(QUANTITY_PER_VERSION_EF, 'quantityPerVersion', 'quantityPerVersionFocus');
    }

    function onQuantityPerVersionBlur () {
        var cquotedata = configureglobals.cquotedata;
        var newValue = getFormItemValue(QUANTITY_PER_VERSION_EF, document);

        dynamic.removeClass('quantityPerVersion', 'focus');
        dynamic.setDivIdContent('quantityPerVersionFocus', '');

        if (newValue === onFocusQuantityPerVersion) {
            return;
        }

        cquotedata.clearFieldErrors(QUANTITY_PER_VERSION_EF);

        var valid = true;

        if (!cquotedata.externallyGenerated) {
            if (!newValue) {
                cquotedata.addFieldError(QUANTITY_PER_VERSION_EF, 'Quantity per version is required.');
                generateQuantity();
                setFieldValue(QUANTITY_PER_VERSION_EF, '', document);
                valid = false;
            } else if (isNaN(parseInt(newValue))) {
                cquotedata.addFieldError(QUANTITY_PER_VERSION_EF, 'Quantity per version must be a valid number.');
                generateQuantity();
                setFieldValue(QUANTITY_PER_VERSION_EF, '', document);
                valid = false;
            }
        }

        if (valid) {
            var configChangeDetails = {
                context: 'changeQuantityPerVersion',
                category: confUtil.OPTION_CHANGE,
                value: ''
            };

            cquotedata.updateQuantityPerVersion(newValue);

            controller.updateQuote(configChangeDetails);
        }
    }

    function onVersionCountFocus () {
        onFocusVersionCount = getFormItemValue(VERSION_COUNT_EF, document);
        common.efFocus(VERSION_COUNT_EF, 'versions', 'versionsFocus');
    }

    function onVersionCountBlur () {
        var versions = configureglobals.cquotedata.versions;
        var updatedVersionCount = getFormItemValue(VERSION_COUNT_EF, document);
        var hasCustomNames = false;

        dynamic.removeClass('versions', 'focus');
        dynamic.setDivIdContent('versionsFocus', '');

        if (updatedVersionCount === onFocusVersionCount) {
            return;
        }

        if (updatedVersionCount.length > 0 && !isNaN(+updatedVersionCount) && +updatedVersionCount < versions.length) {
            for (var index = +updatedVersionCount; index < versions.length; index++) {
                if (versions[index].label !== versions[index].name) {
                    hasCustomNames = true;
                    break;
                }
            }

            if (hasCustomNames) {
                window.confirmPanel.confirm(
                    'By reducing the number of versions to ' + updatedVersionCount + ', you will lose one or more customized version names. Are you sure you wish to modify the number of versions?',
                    function () { // on save
                        updateVersionCount(updatedVersionCount);
                    },
                    function () { // on cancel
                        updateVersionCount(onFocusVersionCount);
                    }
                );
            } else {
                updateVersionCount(updatedVersionCount);
            }
        } else {
            updateVersionCount(updatedVersionCount);
        }
    }

    function updateVersionCount (updatedVersionCount) {
        var cquotedata = configureglobals.cquotedata;

        cquotedata.clearFieldErrors(VERSION_COUNT_EF);

        var valid = true;

        var versionDetailsMsg = ' Version details are still available; please review and set the number of versions to the appropriate value.';

        if (!updatedVersionCount) {
            cquotedata.addFieldError(VERSION_COUNT_EF, 'Number of versions is required.' + versionDetailsMsg);
            valid = false;
        } else if (isNaN(+updatedVersionCount)) {
            cquotedata.addFieldError(VERSION_COUNT_EF, 'Number of versions must be a valid number.' + versionDetailsMsg);
            valid = false;
        } else if (+updatedVersionCount < 2) {
            cquotedata.addFieldError(VERSION_COUNT_EF, 'Number of versions must be at least 2.' + versionDetailsMsg);
            valid = false;
        }

        if (valid) {
            var configChangeDetails = {
                context: 'changeQuantityPerVersion',
                category: confUtil.OPTION_CHANGE,
                value: ''
            };

            cquotedata.updateVersionCount(updatedVersionCount);

            controller.updateQuote(configChangeDetails);
        } else {
            generateQuantity();
            setFieldValue(VERSION_COUNT_EF, '', document);
        }

        common.ef = null;
    }

    function onQuantityFocus () {
        onFocusQuantity = getFormItemValue(QUANTITYEF, document);
        common.efFocus(QUANTITYEF, 'quantity', 'quantityFocus');
    }

    function onQuantityBlur () {
        var cquotedata = configureglobals.cquotedata;

        cquotedata.clearFieldErrors(QUANTITYEF);
        cquotedata.clearGlobalErrors();

        var enteredQuantity = getFormItemValue(QUANTITYEF, document);

        var isValidQuantity = !isNaN(enteredQuantity) && !isNaN(parseInt(enteredQuantity));
        var isEmpty = !enteredQuantity || !enteredQuantity.trim().length;

        if (isEmpty) {
            cquotedata.addFieldError(QUANTITYEF, 'Total quantity is required.');
            cquotedata.addGlobalError('A quote was not completed.  Please make adjustments.');
            common.handleInvalidQuantity(QUANTITYEF, 'quantity', 'quantityFocus', function () {
                cquotedata.updateQuantity(null);
            });
        } else if (!isValidQuantity) {
            cquotedata.addFieldError(QUANTITYEF, 'Total quantity must be a valid number.');
            cquotedata.addGlobalError('A quote was not completed.  Please make adjustments.');
            common.handleInvalidQuantity(QUANTITYEF, 'quantity', 'quantityFocus', function () {
                cquotedata.updateQuantity(null);
            });
        } else {
            common.efBlur(QUANTITYEF, 'quantity', 'quantityFocus', function (newValue) {
                cquotedata.updateQuantity(isValidQuantity ? newValue : null);
            });
        }
    }
}(window));
